import { ApplicationElement, html } from '@effectivastudio/lit-components';
import ChatListItem from '@effectivastudio/lit-components/components/chat_list_item/element.js';
import style from './style.lit.css';
import '@effectivastudio/lit-components/components/badge/element.js';

export default class ChatListItemExtended extends ChatListItem {
  static styles = [ApplicationElement.styles, style];

  renderLabel() {
    return html`<ef-badge count=${this.count} theme="danger"></ef-badge>`;
  }
}

customElements.get('xs-chat-list-item') ||
  customElements.define('xs-chat-list-item', ChatListItemExtended);
